import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const NCEMIBannerContainer = styled.div<{ $disabled: boolean }>(({ theme, $disabled }) => ({
    margin: `${theme.spacing.empty} ${theme.spacing.medium}`,
    marginTop: theme.spacing.xLarge,
    padding: theme.spacing.empty,
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.colors[theme.colorMode].background_Primary,
    borderRadius: theme.cornerRadius.medium,
    pointerEvents: $disabled ? "none" : "auto",
}));

export const NCEMIBannerContent = styled.div<{ $backgroundImage: string; $disabled: boolean }>(
    ({ theme, $backgroundImage, $disabled }) => ({
        padding: theme.spacing.medium,
        display: "flex",
        width: "100%",
        justifyContent: "space-between",
        backgroundImage: $disabled
            ? `linear-gradient(rgba(255,255,255,0.4), rgba(255,255,255,0.4)), url(${$backgroundImage})`
            : `url(${$backgroundImage})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
    }),
);

export const NCEMIBannerContentLeft = styled.div(() => ({
    flex: 1,
}));

export const NCEMIButtonWrapper = styled.div(({ theme }) => ({
    display: "inline-block",
    marginTop: theme.spacing.small,
}));

export const NCEMIBannerFooter = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].warning_Sub,
    padding: `${theme.spacing.xSmall} 14px`,
    borderRadius: theme.cornerRadius.medium,
    margin: theme.spacing.xxxSmall,
    display: "flex",
    flexDirection: "row",
}));

export const DisableText = styled(Text)(({ theme }) => {
    return {
        marginLeft: theme.spacing.xSmall,
    };
});

export const DisableIcon = styled.div(() => {
    return {
        transform: "translateY(0px)",
    };
});
